var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-table',{attrs:{"size":"small","pagination":_vm.pagination,"columns":_vm.columns,"row-key":"index","data-source":_vm.team_data,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }